<template>
  <b-container>
    <b-row class="text-center">
      <b-col></b-col>
      <b-col cols="10">
        <!-- <img src="@/assets/logo/svg/dashtech-alt-logo.svg" width="200px" class="my-3" /> -->
        <h5 class="my-4">Measuring Project Performance</h5>
        <p class="surveyResults">Project Closeout:</p>
        <p class="surveyTitle">{{projectName}}</p>
      </b-col>
      <b-col></b-col>
    </b-row>
    <LoadingIndicator 
      v-if="waiters.projectLoading"
      topic="Project"
    />
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
    <div v-if="!waiters.projectLoading">
      <b-row class="mb-4">
        <b-col>
          <b-button
            variant="warning"
            class="float-left"
            :to="'/project/' + projectId"
          >View Project</b-button>
          <b-button variant="danger" class="float-right" @click="closeProject"
            :disabled="waiters.closeProjectSending" style="width: 120px;"
          >
            <div v-if="!waiters.closeProjectSending">Close Project</div>
            <b-spinner small v-if="waiters.closeProjectSending" label="Spinning"></b-spinner>
          </b-button>
        </b-col>
      </b-row>
      <h5 class="mb-3">Lessons Learned</h5>
      <b-row class="mb-4">
        <b-col cols="12" md="6" class="mb-3">
          <ProjectMetricList
            :projectMetrics="closedRisks"
            title="Closed Risks"
            noneText="No risks"
            :showLimit="0"
            action="LessonLearned"
            :viewByLink="true"
            :presetTags="projectTags"
            @update="refreshProjectMetrics"
          ></ProjectMetricList>

        </b-col>
        <b-col cols="12" md="6" class="mb-3">
          <ProjectMetricList
            :projectMetrics="closedIssues"
            title="Closed Issues"
            noneText="No issues"
            :showLimit="0"
            action="LessonLearned"
            :presetTags="projectTags"
            @update="refreshProjectMetrics"
          ></ProjectMetricList>
        </b-col>
        <b-col cols="12" md="6" class="mb-3">
          <ProjectMetricList
            :projectMetrics="innovations"
            title="Innovations"
            noneText="Innovations"
            :showLimit="0"
            action="LessonLearned"
            :presetTags="projectTags"
            @update="refreshProjectMetrics"
          ></ProjectMetricList>
        </b-col>
        <b-col cols="12" md="6" class="mb-3">
          <ProjectMetricList
            :projectMetrics="efficiencies"
            title="Efficiencies"
            noneText="No efficiencies"
            :showLimit="0"
            action="LessonLearned"
            :presetTags="projectTags"
            @update="refreshProjectMetrics"
          ></ProjectMetricList>
        </b-col>
        <b-col cols="12" md="6" class="mb-3">
          <LessonsLearnedList :lessonsLearned="lessonsLearned"
          :projectId="projectId"
          :showAll="true"
          :allowAdd="true"></LessonsLearnedList>
        </b-col>
      </b-row>
      <h5 class="mb-3">Project Closeout options</h5>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-2-9"
              label="Completed On Time or Early"
              label-for="mark-closed-form-ontime"
            >
              <b-form-checkbox id="mark-closed-form-ontime" v-model="form.onTime"></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-2-10"
              label="Completed Within Budget"
              label-for="mark-closed-form-withinbudget"
            >
              <b-form-checkbox
                id="mark-closed-form-withinbudget"
                v-model="form.withinBudget"
              ></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="fieldset-2-11"
              label="Total Claims"
              label-for="mark-closed-form-total-claims"
              invalid-feedback="Please fill out Total Claims"
            >
              <b-form-input
                id="mark-closed-form-total-claims"
                v-model="form.totalClaims"
                min="0"
                :formatter="$formatter.limitToInt">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <h5 class="mb-3">Project Summary</h5>
      <b-row class="mb-4">
        <b-col lg="3" md="6" cols="6" style="text-align: center;">
          <b-card class="mb-3" border-variant="success">
            <strong>Issues Resolved</strong>
            <div style="font-size:2.5rem">{{closedIssues.length}}</div>
          </b-card>
        </b-col>
        <b-col lg="3" md="6" cols="6" style="text-align: center;">
          <b-card class="mb-3" border-variant="success">
            <strong>Risks Mitigated</strong>
            <div style="font-size:2.5rem">{{closedRisks.length}}</div>
          </b-card>
        </b-col>
        <b-col lg="3" md="6" cols="6" style="text-align: center;">
          <b-card class="mb-3" border-variant="success">
            <strong>Dollars Saved</strong>
            <div style="font-size:2.5rem">${{dollarsSaved}}</div>
          </b-card>
        </b-col>
        <b-col lg="3" md="6" cols="6" style="text-align: center;">
          <b-card class="mb-3" border-variant="success">
            <strong>Days Saved</strong>
            <div style="font-size:2.5rem">{{daysSaved}}</div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";

import ProjectMetricList from "@/components/project/ProjectMetricList.vue";
import LessonsLearnedList from "@/sub-components/LessonsLearnedList.vue";

export default {
  name: "CloseProject",
  components: {
    ProjectMetricList,
    LessonsLearnedList
  },
  data() {
    return {
      errors: [],
      project: null,
      projectId: "",
      projectName: "",
      lessonsLearned: [],
      projectMetrics: [],
      projectTags: [],
      form: {
        onTime: false,
        withinBudget: false,
        totalClaims: ""
      },
      waiters: {
        projectLoading: false,
        closeProjectSending: false
      }
    };
  },
  mounted() {
    if (!this.isSystemAdmin) {
      this.defaultRedirect();
    }
    let projectId = this.$route.params.id;

    this.waiters.projectLoading = true;
    axios.get(`${this.$api_url}/projects/${projectId}/summary?guest=false`,
      this.getReqConfig())
    .then(response => {
      this.project = response.data.project;
      this.projectId = response.data.project.projectId;
      this.projectName = response.data.project.projectName;
      this.projectTags = response.data.project.presetTags;
      this.projectMetrics = response.data.projectMetrics;
    })
    .catch(err => {
      this.errors.push(err);
    })
    .finally(() => {
      this.waiters.projectLoading = false;
    });
  },
  methods: {
    handleAddLessonLearned(lesson) {
      this.lessonsLearned.push(lesson);
    },
    validateCloseProject() {
      const initErrors = this.errors.length;
      this.form = this.$helpers.trimObject(this.form);

      if (this.form.totalClaims && isNaN(this.form.totalClaims)) {
        this.errors.push({ message: "Total Claims must be a number"});
      }

      return initErrors === this.errors.length;
    },
    closeProject() {
      this.errors = [];
      if (!this.validateCloseProject()) { 
        return;
      }

      let request = this.buildUpdateRequest(this.project, this.form);

      this.waiters.closeProjectSending = true;
      //Add lessons learned
      if (this.lessonsLearned.length > 0){
        axios
          .post(`${this.$api_url}/lessons-learned/add-many`, this.lessonsLearned, 
            this.getReqConfig())
          .then(() => {
            //Update Project
            axios
              .post(`${this.$api_url}/projects/update`, request, this.getReqConfig())
              .then(() => {
                this.defaultRedirect();
              })
              .catch(err => {
                this.errors.push(err);
              });
          })
          .catch(err => {
            this.errors.push(err);
          })
          .finally(() => {
            this.waiters.closeProjectSending = false;
          });
      }
      else {
        axios
          .post(`${this.$api_url}/projects/update`, request, this.getReqConfig())
          .then(() => {
            this.defaultRedirect();
          })
          .catch(err => {
            this.errors.push(err);
          })
          .finally(() => {
            this.waiters.closeProjectSending = false;
          });
      }
    },
    buildUpdateRequest(project, form) {
      return {
        projectId: project.projectId,
        projectName: project.projectName,
        category: project.category,
        startDate: project.startDate,
        endDate: project.endDate,
        projectCost: project.projectCost,
        projectIdentifier: project.projectIdentifier,
        status: "Closed",
        onTime: form.onTime,
        withinBudget: form.withinBudget,
        totalClaims: form.totalClaims || 0,
        owner: project.ownerOrganization,
        contractor: project.contractorOrganization,
        primaryOwner: {
          userId: project.primaryOwner.userId,
          name: project.primaryOwner.name,
          email: project.primaryOwner.email,
          phone: project.primaryOwner.phone
        },
        primaryContractor: {
          userId: project.primaryContractor.userId,
          name: project.primaryContractor.name,
          email: project.primaryContractor.email,
          phone: project.primaryContractor.phone  
        }
      }
    },
    refreshProjectMetrics() {
      let url = `${this.$api_url}/projects/${this.projectId}/project-metrics`;
      axios
        .get(url, this.getReqConfig())
        .then(response => {
          this.projectMetrics = response.data;
        })
        .catch(err => {
          if (err.response && err.response.statusText) {
            this.errors.push({ message: err.response.statusText });
          } else {
            this.errors.push(err);
          }
        });
    }
  },
  computed: {
    closedProjectMetrics() {
      return this.projectMetrics.filter(a => a.status === "Closed");
    },
    closedRisks() {
      return this.closedProjectMetrics.filter(a => a.type === "Risk");
    },
    closedIssues() {
      return this.closedProjectMetrics.filter(a => a.type === "Issue");
    },
    innovations() {
      return this.projectMetrics.filter(a => a.type === 'Innovation');
    },
    efficiencies() {
      return this.projectMetrics.filter(a => a.type === 'Efficiency');
    },
    dollarsSaved() {
      return this.projectMetrics.reduce((prev, cur) => prev + 
        ((cur.costSaved && !isNaN(cur.costSaved)) ? cur.costSaved : 0), 0);
    },
    daysSaved() {
      return this.projectMetrics.reduce((prev, cur) => prev + 
        ((cur.timeSaved && !isNaN(cur.timeSaved)) ? cur.timeSaved : 0), 0);
    }
  }
};
</script>

<style scoped>
.surveyResults {
  font-size: 2em;
  line-height: 0.75em;
}
.surveyTitle {
  font-size: 1.75em;
  line-height: 1em;
  color: #555;
}
</style>